<template>
  <AppIcon :icon-name="iconName" class="oet-Plug" height="24" width="24" />
</template>

<script setup>
import { PLUG_ICONS } from '@/utils/cell-helper'
import { includesValue } from '@/utils/prop-validators'

import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'OkrElementsTableCellPlug'
})

defineProps({
  iconName: {
    type: String,
    default: PLUG_ICONS.COMMON,
    validator: v => includesValue(v, PLUG_ICONS)
  }
})
</script>

<style lang="scss" scoped>
.oet-Plug {
  color: $grey-1-next;
  @media (any-hover: hover) {
    &:hover {
      color: $primary-color-next;
    }
  }

  .csi-Item-active &,
  .csi-Plug-active &,
  .odt-Trigger-active & {
    color: inherit;
  }
}
</style>
